import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import ClubCreatedModal from "./modals/ClubCreatedModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Link, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { StripeApiKeyString } from "../../constants/StripeApiKey";
import WidgetInfoModal from "./modals/WidgetInfoModal";

export default function Review({ pendingclub, reviewPendingClub, changeView }) {



  const [isChecked, setIsChecked] = useState(false);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();
  const [clubId, setClubId] = useState(null);
  const [clubCreatedModal, setClubCreatedModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [checkout, setCheckout] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
 
  const [widgetInfo, setWidgetInfo] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const cancelModal = () => {
    setWidgetInfo(false);
  };

  const handleComplete = () => {
    navi("/ClubCreationSuccess");
  };

  const options = {
    clientSecret,
    onComplete: handleComplete,
  };

  const stripePromise = loadStripe(StripeApiKeyString);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };


const handleSubmit = async () => {
  const createPlatformCheckout = {
    embeddedAllowed: selectedPlan === "15"
  };

  try {
    const premResponse = await axios.post(
      `${ApiConnectionString}/api/PlatformCheckout/ClubCreation`,
      createPlatformCheckout,
      { headers: { Authorization: `Bearer ${user.token}` } }
    );
    if (premResponse.status == 200) {
      setClientSecret(premResponse.data);
      setCheckout(true);
    }
  } catch (error) {
    console.error("Error:", error);
  }
};
  const handleCancelCheckout = () => {
    setCheckout(false);
    setClientSecret(null);
    setSelectedPlan(null);
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="lightBlueBanner">
          <p className="fw-bold p-2">Review And Submit</p>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Submission Type</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Details Submitted</td>
              <td>{pendingclub.detailsSubmitted ? "✅" : "❌"}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => changeView("details")}
                >
                  {pendingclub.detailsSubmitted ? "Review/Edit" : "Complete Now"}
                </button>
              </td>
            </tr>
            <tr>
              <td>Images Submitted</td>
              <td>{pendingclub.imagesSubmitted ? "✅" : "❌"}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => changeView("images")}
                >
                  {pendingclub.imagesSubmitted ? "Review/Edit" : "Complete Now"}
                </button>
              </td>
            </tr>
            <tr>
              <td>Classes Submitted</td>
              <td>{pendingclub.classesSubmitted ? "✅" : "❌"}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => changeView("classes")}
                >
                  {pendingclub.classesSubmitted ? "Review/Edit" : "Complete Now"}
                </button>
              </td>
            </tr>
            <tr>
              <td>Payment Options Submitted</td>
              <td>{pendingclub.paymmentOptionsSubmitted ? "✅" : "❌"}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => changeView("paymentOptions")}
                >
                  {pendingclub.paymmentOptionsSubmitted ? "Review/Edit" : "Complete Now"}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className="terms-checkbox">
            <input
              id="terms"
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="terms-checkbox-input"
            />
            <label htmlFor="terms" className="terms-checkbox-label">
              I accept the{" "}
              <Link to="/termsofUse" className="terms-link">
                Terms and Conditions
              </Link>
            </label>
          </div>
        </div>

        {errMessage && <p className="text-danger">{errMessage}</p>}

        {pendingclub.detailsSubmitted &&
          pendingclub.imagesSubmitted &&
          pendingclub.classesSubmitted &&
          pendingclub.paymmentOptionsSubmitted &&
          isChecked && (
            <div>
              <p>
                Creating a club on Membotic includes a 30 day free trial, during
                which your club will be live and fully accessible on the
                platform. After the trial, a subscription is required to keep it
                active. Please choose your plan below.
              </p>

              {!checkout && (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">£10/month</h5>
                        <h6 className="mb-3">Membotic Club Profile</h6>
                        <ul className="list-unstyled">
                          <li>✅ Hosted profile</li>
                          <li>✅ Class timetables</li>
                          <li>✅ Booking system</li>
                          <li>✅ Take payments</li>
                          <li>✅ Analytics</li>
                        </ul>
                        <div className="form-check mt-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="plan"
                            id="plan10"
                            checked={selectedPlan === "10"}
                            onChange={() => setSelectedPlan("10")}
                          />
                          <label className="form-check-label" htmlFor="plan10">
                            Select this plan
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">£15/month</h5>
                        <h6 className="mb-3">Membotic Club Profile + Widget</h6>
                        <ul className="list-unstyled">
                          <li>✅ Hosted profile</li>
                          <li>✅ Class timetables</li>
                          <li>✅ Booking system</li>
                          <li>✅ Take payments</li>
                          <li>✅ Analytics</li>
                          <li className="fw-bold text-primary">✅ Widget for your own website</li>
                          <li className="fw-bold text-primary">✅ Timetable on your website</li>
                          <li className="fw-bold text-primary">✅ Price list on your website</li>
                          <li className="fw-bold text-primary">✅ Take payments on your website</li>
                        </ul>
                        <p
                          onClick={() => {
                            setWidgetInfo(true);
                          }}
                          className="d-block mb-2 text-primary pointer"
                        >
                          Find out more about the widget
                        </p>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="plan"
                            id="plan15"
                            checked={selectedPlan === "15"}
                            onChange={() => setSelectedPlan("15")}
                          />
                          <label className="form-check-label" htmlFor="plan15">
                            Select this plan
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {checkout && selectedPlan === "10" && (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">£10/month</h5>
                        <h6 className="mb-3">Membotic Club Profile</h6>
                        <ul className="list-unstyled">
                          <li>✅ Hosted profile</li>
                          <li>✅ Class timetables</li>
                          <li>✅ Booking system</li>
                          <li>✅ Take payments</li>
                          <li>✅ Analytics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {checkout && selectedPlan === "15" && (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">£15/month</h5>
                        <h6 className="mb-3">Membotic Club Profile + Widget</h6>
                        <ul className="list-unstyled">
                          <li>✅ Hosted profile</li>
                          <li>✅ Class timetables</li>
                          <li>✅ Booking system</li>
                          <li>✅ Take payments</li>
                          <li>✅ Analytics</li>
                          <li className="fw-bold text-primary">✅ Widget for your own website</li>
                          <li className="fw-bold text-primary">✅ Timetable on your website</li>
                          <li className="fw-bold text-primary">✅ Price list on your website</li>
                          <li className="fw-bold text-primary">✅ Take payments on your website</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!checkout && selectedPlan && (
                <button className="saveChanges-button" onClick={handleSubmit}>
                  Start Trial
                </button>
              )}
            </div>
          )}

        {checkout && isChecked && (
          <div id="checkout" className="mt-5 container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Checkout</h5>
              <button className="btn btn-outline-secondary btn-sm" onClick={handleCancelCheckout}>
                Cancel checkout
              </button>
            </div>
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          </div>
        )}

        {clubCreatedModal && <ClubCreatedModal id={clubId} />}

        <button
          className="floating-back-button"
          onClick={() => changeView("paymentOptions")}
        >
          ← Back to Payment Options
        </button>

        {widgetInfo && <WidgetInfoModal cancelModal={cancelModal} />}
      </div>
    );
  }
}
